import React from "react";
import { useParams } from "react-router-dom";
import { DetailArea } from "../DetailArea/DetailArea";
import Layout from "./Layout/Layout";
import "./Style.css";
import { useSeo } from "../../utils/Hooks/useSeo";

export const DetailPage = () => {
  const { id } = useParams();
  const normalizedId = (id || "").trim().toUpperCase();

  useSeo({
    title: normalizedId ? `${normalizedId} in BTC terms` : "Crypto Detail in BTC terms",
    description: normalizedId
      ? `Detailed ${normalizedId} market data in Bitcoin terms, including BTC ATH distance, market cap, and historical SAT price chart.`
      : "Detailed cryptocurrency market data in Bitcoin terms, including BTC ATH distance, market cap, and historical SAT price chart.",
    canonicalPath: id ? `/detail/${encodeURIComponent(id)}` : "/",
    ogType: "article",
  });

  return (
    <Layout>
      <DetailArea id={id}></DetailArea>
    </Layout>
  );
};
